import React from "react";
import "./BeachTrip.css";
import MaldivesEscape from "../../assets/MaldivesEscape.png";
import GoaBeachRetreat from "../../assets/GoaBeachRetreat.png";
import BaliParadise from "../../assets/BaliParadise.png";
import PhuketAdventure from "../../assets/PhuketAdventure.png";
import SantoriniSeaside from "../../assets/SantoriniSeaside.png";
import HawaiiCoastalBliss from "../../assets/HawaiiCoastalBliss.png";
import { useNavigate } from "react-router-dom";

const beachPackages = [
  {
    title: "Maldives Escape",
    image: MaldivesEscape,
    description:
      "Experience crystal clear turquoise waters and soft white sandy beaches in the Maldives. Relax in luxurious overwater villas, enjoy peaceful sunset cruises, and explore colorful coral reefs. This tropical paradise offers ultimate relaxation, breathtaking ocean views, and unforgettable island memories.",
    link: "/tour-package-data",
  },
  {
    title: "Goa Beach Retreat",
    image: GoaBeachRetreat,
    description:
      "Discover Goa’s golden beaches, vibrant nightlife, and delicious seafood cuisine. Enjoy exciting water sports, relaxing beachside cafes, and scenic sunset walks along the shore. A perfect blend of adventure, culture, and coastal relaxation awaits you.",
    link: "/tour-package-data",
  },
  {
    title: "Bali Paradise",
    image: BaliParadise,
    description:
      "Explore Bali’s stunning coastline surrounded by lush greenery and dramatic cliffs. Visit beautiful temples, unwind at beachfront resorts, and enjoy traditional Balinese cuisine. Experience peaceful sunsets, warm hospitality, and unforgettable tropical charm throughout your journey.",
    link: "/tour-package-data",
  },
  {
    title: "Phuket Adventure",
    image: PhuketAdventure,
    description:
      "Enjoy Phuket’s crystal clear waters and exciting island hopping tours. Discover hidden lagoons, limestone cliffs, and vibrant marine life while snorkeling. Relax on sandy beaches and explore lively night markets filled with culture and flavor.",
    link: "/tour-package-data",
  },
  {
    title: "Santorini Seaside",
    image: SantoriniSeaside,
    description:
      "Experience Santorini’s sparkling blue waters and unique volcanic beaches. Wander through charming white villages overlooking the sea and witness breathtaking sunsets. Enjoy Mediterranean cuisine and peaceful seaside stays in this romantic coastal destination.",
    link: "/tour-package-data",
  },
  {
    title: "Hawaii Coastal Bliss",
    image: HawaiiCoastalBliss,
    description:
      "Immerse yourself in Hawaii’s scenic beaches and vibrant island traditions. Surf gentle waves, hike lush trails, and relax under swaying palm trees. Enjoy tropical cuisine and warm hospitality for a refreshing beach escape.",
    link: "/tour-package-data",
  }
      
];

const BeachTrip = () => {
  const navigate = useNavigate();
  return (
    <div className="beach-container">
      <h2 className="beach-title">Beach Holiday Packages</h2>

      <div className="cards-grid">
        {beachPackages.map((item, index) => (
          <div
            className="beach-card"
            key={index}
            onClick={() =>
              navigate(item.link, {
                state: { title: item.title },
              })
            }
          >
            <img src={item.image} alt={item.title} />
            <div className="card-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BeachTrip;
